"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Micro_1 = require("../Micro");
const AlwaysCached_1 = require("./AlwaysCached");
class Macro extends Micro_1.Micro {
    constructor(options = {}) {
        super(options);
        this.alwaysCachedExpireListeners = {};
        this.options = super.options || options;
    }
    _expireKey(key, element) {
        if (element.options.alwaysCached && this.alwaysCachedExpireListeners[key]) {
            if (this.alwaysCachedExpireListeners[key].thisArg) {
                this.alwaysCachedExpireListeners[key].handler.call(this.alwaysCachedExpireListeners[key].thisArg, key, element);
                return;
            }
            this.alwaysCachedExpireListeners[key].handler(key, element);
            return;
        }
        this.delete(key);
    }
    delete(key) {
        return this._delete(key);
    }
    alwaysCachedData(getterFunction, alwaysCachedOptions = {}) {
        return new AlwaysCached_1.AlwaysCached(Object.assign({
            cache: this,
            getterFunction
        }, alwaysCachedOptions));
    }
    static alwaysCachedData(getterFunction, macroOptions = {}, alwaysCachedOptions = {}) {
        return (new Macro(macroOptions)).alwaysCachedData(getterFunction, alwaysCachedOptions);
    }
}
exports.Macro = Macro;
exports.default = Macro;
//# sourceMappingURL=index.js.map